import { defineComponent as _defineComponent } from 'vue'
import EditableToggleBlock from '@/components/EditableToggleBlock.vue'
  import CurrencyInput from '@/components/CurrencyInput.vue'
  import { reactive, ref, watch} from 'vue'
  import { CategoryType } from '@/models/interfaces/content-type'
  import type { CtCatalogue, CtCategory } from '@/models/interfaces/content-type'
  import AddIcon from '@/components/Icons/AddIcon.vue'
  import { useStore } from 'vuex'
  import DButton from '@/components/base/DButton.vue'
  import { ContentType } from '@/services/directr'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StoragePricing',
  props: {
    catalogue: {},
    readonly: { type: Boolean }
  },
  emits: ["update:catalogue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props

  const emits = __emit

  const $directr = useStore().getters['Services/Directr']
  const $store = useStore()

  const categories = ref([] as CtCategory[])
  const fetchCategories = async () => {
    const { items = [] as CtCategory[] } = await $directr.get(ContentType.Category, [{
      select: ['__id', 'name'],
      from: [ContentType.Category],
      where: {
        __id: { in: Object.keys(props.catalogue?.inventory_prices || {}) }
      },
    }], { orm: true })
    categories.value = items
  }
  void fetchCategories()
  watch(() => props.catalogue, fetchCategories)

  const addCategoryModal = reactive({
    visible: false,
    show: (editState) => {
      addCategoryModal.visible = true
      addCategoryModal.queryHandler(editState)
    },
    collection: [] as CtCategory[],
    model: $store.getters[`${ContentType.Category}/Model`],
    searchQuery: null as string | null | undefined,
    queryHandler: (editState, query?: string | null) => {
      addCategoryModal.searchQuery = query
      $directr.get(ContentType.Category, [{
        select: ['__id', 'name'],
        from: [ContentType.Category],
        where: {
          and: [
            { type: { in: [CategoryType.Stock, CategoryType.Product] } },
            { not: [
                { __id: { in: Object.keys(editState.inventory_prices || []) } },
                { name: { in: Object.keys(editState.inventory_prices || []) } }
              ]
            }
          ]
          ,
        },
        limit: 50,
      }], { orm: true }).then(({ items = [] as CtCategory[] }) => {
        addCategoryModal.collection = items
      })
    },
    onSelection: ({ selection }, editState, editingRef) => {
      categories.value = categories.value.concat(selection.filter(s => !categories.value.find(c => c.sys?.id === s.sys.id)))
      editState.inventory_prices = {
        ...editState.inventory_prices,
        ...selection.reduce((acc, curr) => (acc[curr.sys.id] = 0, acc), {})
      }
      editingRef.value = true
    },
  })

  const updateValue = (item, $event, editState, editingRef) => {
    if (editState) {
      editState.inventory_prices[item.sys?.id] = $event
    }
    editingRef.value = true
  }

  const removePrice = (value, editState, editingRef) => {
    if (value.sys.id) {
      delete editState.inventory_prices[value.sys.id]
    }
    editingRef.value = true
  }

  const storagePricingDict = (editState) => {
    return Object.keys(editState?.inventory_prices || []).map((key) => {
      const value: CtCategory | undefined = categories.value.find(i => i.sys?.id === key || i.name === key)
      return {
        ...(value || {}),
        price: (editState?.inventory_prices || {})[key]
      }
    })
  }

const __returned__ = { props, emits, $directr, $store, categories, fetchCategories, addCategoryModal, updateValue, removePrice, storagePricingDict, EditableToggleBlock, CurrencyInput, reactive, ref, watch, get CategoryType() { return CategoryType }, AddIcon, get useStore() { return useStore }, DButton, get ContentType() { return ContentType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})